import { AnalyticsEvent } from '../models';

export interface RewardsEventParams {
    eventType: string;
    rewardTitle?: string;
    rewardsPath?: string;
    rewardsID?: string;
    rewardsType?: string;
    pageName?: string;
    linkName?: string;
    linkTitle?: string;
    linkSection?: string;
    error?: any;
}

export class RewardsEvent implements AnalyticsEvent {
    name = 'RewardsEvent';
    public readonly eventType: string;
    public readonly rewardTitle?: string;
    public readonly rewardsPath?: string;
    public readonly rewardsID?: string;
    public readonly rewardsType?: string;
    public readonly pageName?: string;
    public readonly linkName?: string;
    public readonly linkTitle?: string;
    public readonly linkSection?: string;
    public readonly error?: any;

    constructor(params: RewardsEventParams) {
        this.eventType = params.eventType;
        this.rewardTitle = params.rewardTitle;
        this.rewardsPath = params.rewardsPath;
        this.rewardsID = params.rewardsID;
        this.rewardsType = params.rewardsType;
        this.pageName = params.pageName;
        this.linkName = params.linkName;
        this.linkTitle = params.linkTitle;
        this.linkSection = params.linkSection;
        this.error = params.error;
    }
}